import styles from "./SocialProofMessage.module.scss";

export function SocialProofMessage({
  message,
  usePremiumFont = false,
}: {
  message: string;
  usePremiumFont?: boolean;
}) {
  if (!message) {
    return null;
  }

  return (
    <div
      className={`${styles.socialProofMessage} ${
        usePremiumFont ? styles.bodyS : styles.smallTextBody
      }`}
      data-testid="pcl-social-proof-message"
    >
      {message}
    </div>
  );
}
